<script>
import Header from './Header.vue';
import ScrollToTop from './ScrollToTop.vue'
export default {
  components: {
    'header-component': Header,
    ScrollToTop
  },
  mounted() {
      window.addEventListener('scroll', this.handleScroll);
    },
    methods: {
      handleScroll: function () {
        if (this.scTimer) return;
        this.scTimer = setTimeout(() => {
          this.scY = window.scrollY;
          clearTimeout(this.scTimer);
          this.scTimer = 0;
        }, 100);
      },
      toTop: function () {
        window.scrollTo({
          top: 0,
          behavior: "smooth"
        });
      },

      /* VIDEOS */
      playVideo(url, title){
        let video = document.getElementById("playVideos");
        let videoTitle = document.getElementById("video-title");

        video.src=url;
        videoTitle.innerHTML=title;
        //video.play();
        //video.focus();


      },
      openVideo() {
        let video = document.getElementById("playVideos");
        let videoOverlay = document.getElementById('video-overlay');
        let videoWrap = document.getElementById('video-wrapper');

        if (videoWrap.style.display == "none") {
          videoWrap.style.display = "inline-block";
          videoOverlay.style.display = "block";
        }
      },
      closeVideo() {
        let video = document.getElementById("playVideos");
        let videoOverlay = document.getElementById('video-overlay');
        let videoWrap = document.getElementById('video-wrapper');

        if (videoWrap.style.display == "inline-block") {
          videoWrap.style.display = "none";
          videoOverlay.style.display = "none";
          video.src="";
          //video.pause();
        }
      },
    },
}
</script>

<template>
  <div role="main">
    <div class="top-wrap">
      <div class="top-content">
        <div class="top-banner">
          <header-component></header-component>

          <h1>Collaborative Care Resources</h1>
          <h2><i>Resources to support coordinated care</i></h2>

          <section>
            <p>
              Help support your providers by informing them of the benefits of identifying high-risk adult patients with schizophrenia who may be appropriate for treatment with long-acting injectable antipsychotics (LAIs). Give them tools that help them evaluate their own successes and opportunities and that support engagement between the treatment team and the patient.
            </p>
          </section>

        </div>
      </div>

      <div class="bottom-banner">
        <h3>Resources to Engage Your Provider Network</h3>
        <p class="bottom-banner-text">
          Informing network providers of key metrics related to potential gaps in care, with interventions such as letters or dashboard reports, is an important component of disease management aimed at impacting prescribing patterns, healthcare utilization, and costs.<sup>1,2</sup>
        </p>
      </div>
    </div>

    <div class="list-content">
      <div class="list-wrap">

        <div class="list-item">
          <div class="web-icon">The State of Schizophrenia</div>
          <p>Tune in to a discussion with clinicians about the stigma and burden of schizophrenia.</p>
          <a href="https://talkinglais.com/reducing-series-ep1" aria-label="Visit The State of Schizophrenia website" target="_blank"  class="button visit">VISIT SITE <img src="../img/visit-icon.png" alt=""/></a>
        </div>
        <div class="list-item">
          <div class="web-icon">The Cost of  Repeated Relapse</div>
          <p>Hear what a panel of clinicians says about the consequences of repeated relapse in adult patients with schizophrenia, such as loss of work.</p>
          <a href="https://talkinglais.com/reducing-series-ep2" aria-label="Visit The Cost of Repeated Relapse website" target="_blank"  class="button visit">VISIT SITE <img src="../img/visit-icon.png" alt=""/></a>
        </div>

        <div class="list-item">
          <div class="web-icon">Benefits of LAI Intervention</div>
          <p>Listen to a discussion with clinicians about biases and outcomes when evaluating treatment with LAI intervention for adult patients with schizophrenia.</p>
          <a href="https://talkinglais.com/reducing-series-ep3" aria-label="Visit Benefits of LAI Intervention website" target="_blank"  class="button visit">VISIT SITE <img src="../img/visit-icon.png" alt=""/></a>
        </div>
        <div class="list-item">
          <div class="web-icon">Why Are LAIs Underutilized?</div>
          <p>Attend a broadcast of clinicians detailing why treatment with LAIs is underutilized (eg, stigma, lack of awareness, or access) in adult patients with schizophrenia.</p>
          <a href="https://talkinglais.com/reducing-series-ep4" aria-label="Visit Why Are LAIs Underutilized website" target="_blank"  class="button visit">VISIT SITE <img src="../img/visit-icon.png" alt=""/></a>
        </div>
        <div class="list-item">
          <div class="web-icon">Improving How HCPs Offer Patients LAIs</div>
          <p>Learn how practicing clinicians proactively approach the conversation around treatment with LAIs with adult patients with schizophrenia. </p>
          <a href="https://talkinglais.com/reducing-series-ep5" aria-label="Visit Improving How HCPs Offer Patients LAIs website" target="_blank"  class="button visit">VISIT SITE <img src="../img/visit-icon.png" alt=""/></a>
        </div>

        <div class="list-item">
          <div class="web-icon">Importance of the Therapeutic Alliance</div>
          <p>Understand how to overcome potential roadblocks to treatment with LAIs and the importance of the Therapeutic Alliance and caregiver engagement.</p>
          <a href="https://talkinglais.com/reducing-series-ep6" aria-label="Visit Importance of the Therapeutic Alliance website" target="_blank"  class="button visit">VISIT SITE <img src="../img/visit-icon.png" alt=""/></a>
        </div>
        <div class="list-item">
          <div class="web-icon">Shared Decision Making and LAIs</div>
          <p>Discuss the shared decision-making process and considerations for successful dialogue around treatment with LAIs.</p>
          <a href="https://talkinglais.com/reducing-series-ep7" aria-label="Visit Shared Decision Making and LAIs website" target="_blank"  class="button visit">VISIT SITE <img src="../img/visit-icon.png" alt=""/></a>
        </div>
        <div class="list-item">
          <div class="web-icon">How to Give LAIs</div>
          <p>A review for nurses and other psychiatric healthcare professionals about how to give LAI intramuscular injections.</p>
          <a href="https://www.janssenmd.com/intramuscularinjections" aria-label="Visit How to Give LAIs website" target="_blank"  class="button visit">VISIT SITE <img src="../img/visit-icon.png" alt=""/></a>
        </div>

      </div>
    </div>

    <div class="body toEngage">
      <p class="subhead">Resources to Engage Patients and Caregivers</p>
      <p>
        Patient and caregiver engagement is a fundamental priority of the National Quality Strategy, and it is critical in the ongoing treatment and management of schizophrenia.<sup>3</sup>
        Assisting patients in understanding their schizophrenia treatment choices and facilitating shared decision making among patients and providers is a common goal among many healthcare organizations.<sup>3</sup>
      </p>
      <p>
        The following resources are for healthcare providers to engage in active discussions with patients, helping them think through the pros and cons of treatments and guiding them toward a recovery plan that they are invested in.
      </p>
      <p class="subhead blue">Shared Decision-Making Resources</p>


        <div class="body-list-wrap">

          <div class="body-list-item">
            <div class="pdf-icon">Goal Setting</div>
            <p>Information and exercises to help patients build goal-setting skills.</p>
            <a href="https://www.hopeforschizophrenia.com/pdf/en/cp-54209v6.pdf" aria-label="Download Goal Setting PDF" target="_blank"  class="button download">DOWNLOAD <img src="../img/down-icon.png" alt=""/></a>
          </div>
          <div class="body-list-item">
            <div class="pdf-icon">Problem Solving</div>
            <p>Help patients identify challenges related to achieving treatment goals and to find solutions through informative exercises.</p>
            <a href="https://www.hopeforschizophrenia.com/pdf/en/cp-55401v7.pdf" aria-label="Download Problem Solving PDF" target="_blank"  class="button download">DOWNLOAD <img src="../img/down-icon.png" alt=""/></a>
          </div>
          <div class="body-list-item">
            <div class="pdf-icon">Making Choices</div>
            <p>Informative document to help patients make decisions that are right for them.</p>
            <a href="https://www.hopeforschizophrenia.com/pdf/en/cp-54300v7.pdf" aria-label="Download Making Choices PDF" target="_blank"  class="button download">DOWNLOAD <img src="../img/down-icon.png" alt=""/></a>
          </div>

          <div class="body-list-item">
            <div class="pdf-icon">Partners in Care</div>
            <p>Assist patients with getting loved ones involved in their recovery journeys.</p>
            <a href="https://www.hopeforschizophrenia.com/pdf/en/cp-53757v7.pdf" aria-label="Download Partners in Care PDF" target="_blank"  class="button download">DOWNLOAD <img src="../img/down-icon.png" alt=""/></a>
          </div>
          <div class="body-list-item">
            <div class="pdf-icon">Explore Your Beliefs</div>
            <p>Get patients to think about their personal beliefs when it comes to their medications.</p>
            <a href="https://www.hopeforschizophrenia.com/pdf/en/cp-110941v4.pdf" aria-label="Download Explore Your Beliefs PDF" target="_blank"  class="button download">DOWNLOAD <img src="../img/down-icon.png" alt=""/></a>
          </div>
          <div class="body-list-item">
            <div class="pdf-icon">Making Decisions Together</div>
            <p>Assistance to help patients become active partners in their treatment and recovery.</p>
            <a href="https://www.hopeforschizophrenia.com/pdf/en/cp-63642v7.pdf" aria-label="Download Making Decisions Together PDF" target="_blank"  class="button download">DOWNLOAD <img src="../img/down-icon.png" alt=""/></a>
          </div>

          <div class="body-list-item">
            <div class="pdf-icon">Making Medication Decisions</div>
            <p>Support patients to begin conversations with their treatment teams about their preferences.</p>
            <a href="https://www.hopeforschizophrenia.com/pdf/en/cp-110940v4.pdf" aria-label="Download Making Medication Decisions PDF" target="_blank"  class="button download">DOWNLOAD <img src="../img/down-icon.png" alt=""/></a>
          </div>
          <div class="body-list-item">
            <div class="pdf-icon">Treatment and Recovery Log</div>
            <p>Patients can keep track of their medication preferences and recovery histories with this helpful resource.</p>
            <a href="https://www.hopeforschizophrenia.com/pdf/en/cp-25171v7.pdf" aria-label="Download Treatment and Recovery Log PDF" target="_blank"  class="button download">DOWNLOAD <img src="../img/down-icon.png" alt=""/></a>
          </div>

        </div>
    </div>

    <div class="list-content">

      <p class="subhead blue">Resources for Patients and Caregivers</p>
      <p class="subhead-description">
        Patients and their caregivers also need to be aware of the condition, treatment options, and potential adverse events. The resources below can help patients take a more active role in managing their condition and encourage interactions with healthcare providers for ongoing care coordination.
      </p>

      <div class="list-wrap">
        <div class="list-item">
          <div class="web-icon">Schizophrenia Education</div>
          <p>Videos for adult patients with schizophrenia to better understand their schizophrenia diagnosis, treatment options (including outpatient treatment), symptoms, and myths versus facts.</p>
          <a href="https://www.hopeforschizophrenia.com/what-is-schizophrenia/" aria-label="Visit Schizophrenia Education website" target="_blank"  class="button visit">VISIT SITE <img src="../img/visit-icon.png" alt=""/></a>
        </div>
        <div class="list-item">
          <div class="web-icon">Caregiver Education</div>
          <p>Videos to support caregivers on topics such as practical tips, the importance of self-care, and how to support a loved one living with schizophrenia.</p>
          <a href="https://www.hopeforschizophrenia.com/caring-for-your-loved-one/" aria-label="Visit Caregiver Education website" target="_blank"  class="button visit">VISIT SITE <img src="../img/visit-icon.png" alt=""/></a>
        </div>

        <div class="list-item">
          <div class="web-icon">Understanding Supportive Therapies</div>
          <p>Learn about supportive therapy options such as cognitive behavioral therapy, counseling, and Certified Peer Support Specialists through short videos. Scroll toward the bottom of the website page to find the resources.</p>
          <a href="https://www.hopeforschizophrenia.com/schizophrenia-therapies/" aria-label="Visit Understanding Supportive Therapies website" target="_blank"  class="button visit">VISIT SITE <img src="../img/visit-icon.png" alt=""/></a>
        </div>

        <ScrollToTop />

      </div>

      <div class="video-wrapper video-closed" id="video-wrapper" style="display:none;">
        <div class="video-close" id="video-close"  @click="closeVideo();">X</div>
        <div class="video-title" id="video-title">Video Title</div>
        <iframe id="playVideos" src="" allowfullscreen="" allow="encrypted-media" style="top: 0px; right: 0px; bottom: 0px; left: 0px; width: 100%; height: 90%;"></iframe>
        <!--<video id="playVideos" controls disablePictureInPicture>
          <source id="playVideosss"  type="video/mp4">
        </video>-->
      </div>
      <div id="video-overlay" class="overlay" @click="closeVideo();"></div>

    </div>

    <div class="body footer-references">
      <p class="references">
        <strong>References: 1.</strong> Mattke S, Higgings A, Brook R. Results from a national survey on chronic care management by health plans. <i>Am J Manag Care</i>. 2015;21(5):370-376.
        <strong>2.</strong> Ho M-J, Venci J. Improving the success of mailed letter intervention programs to influence prescribing behaviors: a review. <i>J Manag Care Pharm</i>. <span>2012;18(8):627
        -649.</span> doi:10.18553/jmcp.2012.18.8.627 <strong>3.</strong> National Priorities Partnership; National Quality Forum. Input to the Secretary of Health and Human Services on Priorities
        for the 2011 National Quality Strategy. Washington, DC: National Quality Forum; October 14, 2010. Accessed November 20, 2023. <span><a style="display: inline; color: #363636;word-break: break-all;" href="http://www.qualityforum.org/Setting_Priorities/National_Priorities_Partnership_Input_to_HHS_on_the_National_Quality_Strategy.aspx" target="_blank">http://www.qualityforum.org/<br>
        Setting_Priorities/National_Priorities_Partnership_Input_to_HHS_on_the_National_Quality_Strategy.aspx</a></span>
      </p>
    </div>

  </div>


</template>

<style scoped>
#app>div {
  width: 100%;
}

/*TOP */

.top-wrap {
  background: rgb(0, 18, 82);
  background: linear-gradient(0deg, rgba(0, 18, 82, 1) 0%, rgba(0, 70, 126, 1) 50%, rgba(0, 70, 126, 1) 100%);
  color: #ffffff;
  padding-bottom: 60px;
  width: 100%;
}

.top-content {
  background: linear-gradient(to top, #0079A8, #0084B8);
  border-radius: 0 0 0 100px;
  /*height: 539px;*/
  margin-left: 3%;
  width: 97%;
}

.top-banner {
  background: url(../img/banner-bg.png) no-repeat 0 0;
  background-size: cover;
  border-radius: 0 0 0 100px;
  /*height: 483px;*/
  margin-left: 1.5%;
  margin-bottom: 56px;
  padding-bottom: 78px;
  width: 98.5%;
}

.top-banner section p {
  margin: 1em auto;
}

.top-banner h1 {
  display: block;
  font-family: "Gotham", sans-serif;
  font-size: 36px;
  font-weight: 700;
  line-height: 36px;
  margin: 68px auto 30px auto;
  max-width: 1121px;
  text-align: center;
}

.top-banner h2 {
  display: block;
  font-family: "GothamBook", sans-serif;
  font-size: 22px;
  font-style: italic;
  font-weight: 400;
  line-height: 24px;
  margin: 0 auto;
  max-width: 1121px;
  text-align: center;
}

.top-banner section {
  font-family: "GothamBook", sans-serif;
  font-size: 18px;
  font-weight: 700;
  line-height: 24px;
  margin: 40px auto 0 auto;
  text-align: center;
  max-width: 1121px;
}

.top-content p.banner-footer {
  font-family: "GothamBook", sans-serif;
  font-size: 24px;
  text-align: center;
}

.bottom-banner {
  color: #00a0df;
  display: block;
  font-family: "GothamBook", sans-serif;
  font-size: 20px;
  font-weight: 700;
  margin: 70px auto 0 auto;
  text-align: left;
  width: 1140px;
}

.bottom-banner h3{
  font-size: 20px;
  color: #FFFFFF;
}

.bottom-banner-text {
  color: #ffffff;
  font-family: GothamBook, sans-serif;
  font-size: 16px;
  font-weight: 400;
  line-height: 20px;
}

.list-content {
  background: #eeeef3;
  font-family: GothamBook, sans-serif;
  font-size: 16px;
  line-height: 20px;
  margin: 5px auto;
  padding: 60px 0 0 0;
  width: 100%;
}

.list-content>p {
  width: 90%;
  margin: 0 auto;
}

.list-wrap {
  background: #eeeef3;
  display: block;
  margin: 65px auto 0 auto;
  position: relative;
  width: 1121px;
}

.list-item {
  background-color: #ffffff;
  border-radius: 0 35px 0 35px;
  box-shadow: 10px -5px 30px 0px rgba(0, 0, 0, 0.15);
  -moz-box-shadow: 10px -5px 30px 0px rgba(0, 0, 0, 0.15);
  -webkit-box-shadow: 10px -5px 30px 0px rgba(0, 0, 0, 0.15);
  height: 400px;
  margin: 0 34px 78px 0;
  position: relative;
  vertical-align: top;
  width: 347px;
}

.list-item:nth-child(3n) {
  margin: 0 0 78px 0;
}

.list-item div {
  color: #000000;
  display: block;
  font-family: "Gotham", sans-serif;
  font-size: 20px;
  font-weight: 700;
  line-height: 24px;
  margin: 30px;
  min-height: 52px;
  padding-right: 25%;
}


.list-item p {
  color: #000000;
  font-family: GothamBook, sans-serif;
  font-size: 14px;
  font-weight: 400;
  margin: 0 30px;
  line-height: 17px;
}

.list-item .button {
  background: rgb(26, 64, 132);
  background: linear-gradient(90deg, rgba(26, 64, 132, 1) 0%, rgba(84, 51, 143, 1) 80%, rgba(84, 51, 143, 1) 100%);
  border-radius: 0 0 0 35px;
  border: 0px;
  height: 70px;
  border-top: 4px solid #1c75bc;
  bottom: 0px;
  color: #ffffff;
  font-family: "GothamBook", sans-serif;
  font-size: 18px;
  font-weight: bold;
  line-height: 60px;
  margin: 0;
  padding: 0 70px 0 0;
  position: absolute;
  text-align: right;
  text-decoration: none;
  width: calc(100% - 70px);
}

.list-item .button img {
  position: absolute;
  top: 14px;
  right: 15px;
}

.list-item .button.visit {
  background: rgb(21, 129, 198);
  background: linear-gradient(90deg, rgba(21, 129, 198, 1) 0%, rgba(2, 164, 226, 1) 100%);
  border-top-color: #00467e;
}

.body-list-wrap {
  display: block;
  margin: 65px auto 0 auto;
  width: 1121px;
}

.body-list-item {
  background-color: #ffffff;
  border-radius: 0 35px 0 35px;
  box-shadow: 10px -5px 30px 0px rgba(0, 0, 0, 0.15);
  -moz-box-shadow: 10px -5px 30px 0px rgba(0, 0, 0, 0.15);
  -webkit-box-shadow: 10px -5px 30px 0px rgba(0, 0, 0, 0.15);
  height: 400px;
  margin: 0 32px 78px 0;
  position: relative;
  vertical-align: top;
  width: 338px;
}

.body-list-item:nth-child(3n) {
  margin: 0 0 78px 0;
}

.body-list-item div {
  color: #000000;
  display: block;
  font-family: "Gotham", sans-serif;
  font-size: 20px;
  font-weight: 700;
  line-height: 24px;
  line-height: 24px;
  margin: 30px;
  min-height: 55px;
  padding-right: 29%;
}

.body-list-item p {
  color: #000000;
  font-family: GothamBook, sans-serif;
  font-size: 14px;
  font-weight: 400;
  margin: 0 30px;
  min-height: 78px;
  line-height: 17px;
}

.body-list-item .button {
  background: rgb(26, 64, 132);
  background: linear-gradient(90deg, rgba(26, 64, 132, 1) 0%, rgba(84, 51, 143, 1) 80%, rgba(84, 51, 143, 1) 100%);
  border-radius: 0 0 0 35px;
  border: 0px;
  height: 70px;
  border-top: 4px solid #1c75bc;
  bottom: 0px;
  color: #ffffff;
  font-family: "GothamBook", sans-serif;
  font-size: 18px;
  font-weight: bold;
  line-height: 60px;
  margin: 0;
  padding: 0 70px 0 0;
  position: absolute;
  text-align: right;
  text-decoration: none;
  width: calc(100% - 70px);
}

.body-list-item .button img {
  position: absolute;
  top: 14px;
  right: 15px;
}

.body-list-item .button.visit {
  background: rgb(21, 129, 198);
  background: linear-gradient(90deg, rgba(21, 129, 198, 1) 0%, rgba(2, 164, 226, 1) 100%);
  border-top-color: #00467e;
}


.pdf-icon {
  background: url(../img/pdf-icon.png) no-repeat top right;
}

.xls-icon {
  background: url(../img/xls-icon.png) no-repeat top right;
}

.ppt-icon {
  background: url(../img/ppt-icon.png) no-repeat top right;
}

.web-icon {
  background: url(../img/web-icon.png) no-repeat top right;
}

.xls-icon {
  background: url(../img/xls-icon.png) no-repeat top right;
}

.doc-icon {
  background: url(../img/doc-icon.png) no-repeat top right;
}

.body-list-item a.no-icon {
  padding-right: 0;
}

.video-thumb {
  cursor: pointer;
  margin-top: 20px;
  text-align: center;
  width: 100%;
}

.steps {
  margin-top: 29px;
}

.step-item {
  border-bottom: 1px solid #6689a5;
  margin-bottom: 21px;
  padding-bottom: 23px;
}

.step-item:last-child {
  border: 0;
}

.step-circle {
  background-color: #00a0df;
  border-radius: 50px;
  color: #0f3765;
  font-size: 18px;
  height: 40px;
  padding: 30px;
  width: 40px;
  text-align: center;
}

.step-item-desc-wrap {
  color: #ffffff;
  display: inherit;
  float: right;
  font-family: GothamBook, sans-serif;
  font-size: 16px;
  left: 24%;
  margin-left: 44px;
  width: 996px;
}

.step-title {
  font-family: GothamBook, sans-serif;
  font-weight: bold;
  margin: 0 0 0 -17px;
  padding: 0;
}

.step-desc {
  display: list-item;
  font-family: GothamBook, sans-serif;
  font-weight: 400;
}

.step-desc.dash {
  list-style-type: none;
  text-indent: 6px;
}

.step-desc.dash:before {
  content: "-";
  left: -6px;
  position: relative;
}

.mapping-list {
  color: #ffffff;
  font-weight: 400;
  margin-bottom: 80px;
  padding-left: 20px;
}

.mapping-list li {
  display: list-item;
  font-family: GothamBook, sans-serif;
  font-size: 16px;
  line-height: 24px;
  list-style-type: disc;
}

.body {
  display: block;
  font-family: GothamBook, sans-serif;
  font-size: 16px;
  margin: 59px auto 0 auto;
  line-height: 20px;
  width: 1121px;
}

.body.toEngage {
  font-size: 18px;
  line-height: 24px;
}

.body .references {
  display: block;
  font-family: "GothamBook", sans-serif;
  font-size: 14px;
  line-height: 21px;
  margin: 0;
  width: 1121px;
  word-break: break-word;
}

.body sup {
  font-size: 11px;
  font-weight: 400;
  margin: 0 0 0 2px;
  vertical-align: text-bottom;
}

.body .subhead {
  margin-bottom: 40px;
}

.subhead {
  color: #6f6f6f;
  font-family: "GothamBook", sans-serif;
  font-size: 20px;
  font-weight: bold;
  line-height: 25px;
  max-width: 1121px;
}

.body.toEngage .subhead {
  line-height: 20px;
}

.body.toEngage p {
  color:#000000;
}




.subhead.blue {
  color: #0D6DA5 !important;
  font-family: 'GothamBook';
  font-weight: 400;
  margin-bottom: 20px;
}

.subhead-description {
  max-width: 1121px;
  color:#000000;
}

.top-link {
  background: url(../img/icon-backToTop.png) no-repeat center right;
  bottom: -48px;
  color: #A65103;
  font-family: GothamMedium, sans-serif;
  font-size: 18px;
  position: absolute;
  right: 115px;
  display: inline-flex;
  cursor: pointer;
  align-items: center;
  line-height: 42px;
  padding-right: 56px;
}

strong {
  font-weight: bold;
  color:#000000;
}

.footer-references span {
  word-break: break-all;
}

.video-wrapper {
  background-color: #ffffff;
  padding: 20px 48px 48px 48px;
  position: fixed;
  height: 400px;
  width: 635px;
  z-index: 11100;
  top: 10%;
  left: 0;
  right: 0;
  bottom: 0;
  margin: auto;
  max-width: 95%;
  text-align: left;
}

.video-wrapper .video-title {
  color: #1b4084;
  font-family: GothamBook, sans-serif;
  font-size: 30px;
  font-weight: bold;
  margin-bottom: 35px;
}

.video-wrapper .video-tag {
  width: 100%;
}

.video-wrapper .video-close {
  background: url(../img/close-video.jpeg) no-repeat center right;
  cursor: pointer;
  font-size: 0;
  height: 25px;
  margin: 7px 25px 0 0;
  position: absolute;
  right: 0;
  width: 25px;
}

.video-wrapper video {
  width: 100%;
}

.overlay {
  position: fixed;
  display: none;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 11000;
  cursor: pointer;
}

@media screen and (max-width: 1230px) {

  footer img {
    left: 78%;
  }

  .top-banner *,
  .body * {
    max-width: 95%;
  }

  .body {
    max-width: 90%;
  }

  .bottom-banner * {
    max-width: 99%;
  }

  .step-item-desc-wrap {
    max-width: 80%;
  }

  .bottom-banner,
  .list-wrap,
  .home-body {
    width: 90%;
  }

  .list-wrap {
    margin-bottom: 0;
    /*text-align: center;*/
  }

  .list-item,
  .body-list-item {
    margin: 0 37px 60px 0;
    text-align: left;
    width: 317px;
  }

  .list-item *,
  .body-list-item * {
    max-width: 100%;
  }

  .body-list-item:nth-child(3n) {
    margin: 0 37px 60px 0;
  }

  .body .references {
    margin: 0 auto;
  }

}

@media screen and (max-width: 1024px) {
  .top-banner h2 {
    width: 96%;
  }

  .bottom-banner {
    padding-left: 60px;
    padding-right: 60px;
    width: calc(100% - 120px);
  }

  .step-item-desc-wrap {
    max-width: 95%;
    text-align: left;
    width: 95%;
  }

  .step-item {
    text-align: center;
  }

  .step-circle {
    margin: 60px 0 45px 0;
  }

  .list-wrap {
    padding-bottom: 50px;
    padding-left: 55px;
    width: calc(75% - 55px);
  }

  .list-item {
    margin-right: 38px;
    width: 300px;
  }

  .list-item:nth-child(3n) {
    margin: 0 38px 78px 0;
  }

  .list-item button {
    width: 300px;
    background-size: contain;
  }

  .body {
    width: 90%;
  }

  .body-list-wrap,
  .body .references,
  .body-list-item button {
    width: 100%;
  }

  .body-list-wrap {
    max-width: 100%;
    text-align: center;
    width: 100%;
  }

  .body-list-item {
    margin-right: 32px;
    width: 300px;
  }

  .list-content>p {
    width: 82%;
  }

  .top-link {
    bottom: 35px;
    right: 35px;
  }

  .video-wrapper {
    background-color: #ffffff;
    padding: 20px 48px 48px 48px;
    position: fixed;
    top: 5%;
    left: 0;
    right: 0;
    bottom: 0;
    margin: auto 13%;
    padding: 20px 5% 20px 5%;
    position: fixed;
    height: 400px;
    width: 635px;
    z-index: 11100;
  }

  .video-wrapper .video-title {
    color: #1b4084;
    font-family: GothamBook, sans-serif;
    font-size: 15px;
    font-weight: bold;
    margin-bottom: 30px;
  }

  .video-wrapper .video-tag {
    width: 100%;
  }

  .video-wrapper .video-close {
    background: url(../img/close-video.jpeg) no-repeat center right;
    cursor: pointer;
    font-size: 0;
    height: 25px;
    margin: 7px 25px 0 0;
    position: absolute;
    right: 0;
    width: 25px;
  }

  .video-wrapper video {
    width: 100%;
  }
}

@media screen and (max-width: 880px) {

  .top-banner {
    background: url(../img/banner-mobile3-bg.png) no-repeat 0 0;
    background-size: cover;
    border-radius: 0 0 0 100px;
    margin-left: 1.5%;
    padding-bottom: 46px;
    width: 98.5%;
    margin-bottom: 28px;
  }

  .top-banner section {
    font-family: GothamBook, sans-serif;
    font-size: 20px;
    line-height: 30px;
    width: 86%;
  }

  .top-content p.banner-footer {
    font-size: 30px;
    margin: 24px auto;
    width: 73%;
  }

  .resources {
    margin: 80px auto 0 auto;
    width: 80%;
  }

  .resources>div {
    padding-left: 0;
    margin-right: 28px;
    margin-bottom: 70px;
    width: 297px;
  }

  .resources div:nth-child(2n) {
    margin-right: 0;
    width: 260px;
  }

  .resources div:nth-child(2n) .resource_info_wrap {
    border-right: 0;
    margin: 0 0 25px 0;
  }

  .resources .resource_info_wrap {
    margin: 0 37px 25px 0;
    padding-right: 0px;
    width: 100%;
  }

  .home-body {
    width: 87%;
  }

  .top-banner h2 {
    width: 96%;
  }

  .bottom-banner {
    padding-left: 60px;
    padding-right: 60px;
    width: calc(100% - 120px);
  }

  .step-item-desc-wrap {
    max-width: 95%;
    text-align: left;
    width: 95%;
  }

  .step-item {
    text-align: center;
  }

  .step-circle {
    margin: 60px 0 45px 0;
  }

  .list-wrap {
    padding-bottom: 50px;
    padding-left: 55px;
    width: calc(100% - 55px);
  }

  .list-item {
    margin-right: 38px;
    width: 300px;
  }

  .list-item:nth-child(3n) {
    margin: 0 38px 78px 0;
  }

  .list-item button {
    width: 300px;
    background-size: contain;
  }

  .body {
    width: 90%;
  }

  .body-list-wrap,
  .body .references,
  .body-list-item button {
    width: 100%;
  }

  .body-list-wrap {
    max-width: 100%;
    text-align: center;
    width: 100%;
  }

  .body-list-item {
    margin-right: 32px;
    width: 300px;
  }

  .list-content>p {
    width: 82%;
  }

  .top-link {
    bottom: 35px;
    right: 35px;
  }

  .video-wrapper {
    background-color: #ffffff;
    position: fixed;
    top: 6%;
    left: 0;
    right: 0;
    bottom: 0;
    margin: auto 22%;
    padding: 20px 5% 20px 5%;
    position: fixed;
    height: 215px;
    width: 45%;
    z-index: 11100;
  }

  .video-wrapper .video-title {
    color: #1b4084;
    font-family: GothamBook, sans-serif;
    font-size: 15px;
    font-weight: bold;
    line-height: 25px;
    margin-bottom: 10px;
  }

  .video-wrapper .video-tag {
    width: 100%;
  }

  .video-wrapper .video-close {
    background: url(../img/close-video.jpeg) no-repeat center right;
    cursor: pointer;
    font-size: 0;
    height: 25px;
    margin: 0px 25px 0 0;
    position: absolute;
    right: 0;
    width: 25px;
  }

  #playVideos {
    height: 87% !important;
  }

  .video-wrapper video {
    width: 100%;
  }

  .video-thumb img {
    width: 88%;
  }

}


@media screen and (max-width: 540px) {

  .body sup {
    font-size: 8px;
  }

  .list-wrap {
    padding-bottom: 50px;
    padding-left: 55px;
    width: calc(74% - 55px);
  }

  .top-banner h1 {
    font-size: 19px;
    line-height: 23px;
    max-width: 85%;
    margin: 40px auto 0 auto;
  }

  .top-banner h2 {
    display: block;
    font-size: 19px;
    line-height: 23px;
  }


  .top-banner section {
    font-size: 13px;
    line-height: 16px;
  }

  .top-content p.banner-footer {
    font-size: 15px;
    line-height: 18px;
  }

  .video-wrapper {
    background-color: #ffffff;
    position: fixed;
    top: 6%;
    left: 0;
    right: 0;
    bottom: 0;
    margin: auto 5%;
    padding: 20px 5% 20px 5%;
    position: fixed;
    height: 215px;
    width: 80%;
    z-index: 11100;
  }

}

@media screen and (max-width: 415px) {

  .resources .resource_info_wrap {
    border-right: 0;
    margin: 0 0 25px 0;
  }

  .resources div a {
    display: block;
    height: 55px;
  }

  .resources>div button {
    width: 100%;
  }

  .resources>div,
  .resources div:nth-child(2n) {
    width: 100%;
  }

  .bottom-banner {
    padding-left: 30px;
    padding-right: 30px;
    width: calc(100% - 60px);
  }

  .list-wrap {
    padding-left: 0;
    text-align: center;
    width: 100%;
  }

  .list-item {
    margin: 0 0 60px 0;
  }

  .list-item:nth-child(3n) {
    margin: 0 0 60px 0;
  }

  .top-banner section {
    font-size: 23px;
  }

  .body {
    width: 87%;
  }

  .body-list-item,
  .body-list-item:nth-child(2n),
  .body-list-item:nth-child(3n) {
    margin: 0 0 78px 0;
  }

  .body-list-item:nth-child(3n) {
    margin: 0 0 78px 0 !important;
  }

  .body .references {
    max-width: 100%;
  }

  .top-banner h1 {
    font-size: 18px;
    line-height: 23px;
    width: 70%;
    margin: 40px auto 20px auto;
  }

  .top-banner h2 {
    font-size: 16px;
    line-height: 18px;
    width: 70%;
  }

  .top-banner h1 span {
    display: block;
    font-size: 14px;
    line-height: 18px;
    margin-top: 20px;
  }

  .top-banner section {
    font-size: 14px;
    font-weight: 400;
    line-height: 16px;
    margin-top: 0;
  }

  .top-content p.banner-footer {
    font-size: 15px;
    line-height: 18px;
  }

  .bottom-banner {
    font-size: 15px;
    line-height: 20px;
    margin-top: 36px;
  }

  .bottom-banner h3{
    font-size: 15px;
  }

  .bottom-banner-text {
    font-size: 15px;
    line-height: 20px;
  }

  .body {
    font-size: 14px;
    line-height: 16px;
  }

  .body .subhead {
    margin-top: 30px;
    font-size: 15px;
    line-height: 18px;
  }

  .list-content {
    padding: 0;
    font-size: 14px;
  }

  .list-content .subhead.blue {
    color: #0D6DA5 !important;
    margin-top: 30px;
    font-size: 15px;
  }

  @supports (-webkit-touch-callout: none) {
    .filter-list span {
      line-height: 32px;
    }

    .filter-content .apply {
      line-height: 70px;
    }

    .top-link {
      padding-top: 12px;
    }

  }

}

/* new styles sergio */

@media screen and (max-width: 880px) {
  .top-banner header .logo img {
    width: 60%;
  }
}

@media screen and (orientation:portrait) {
  .video-wrapper {
    top: 25%;
  }
}

@media screen and (orientation:landscape) and (max-height: 736px) and (max-width: 1000px) {
  .video-wrapper {
    max-height: 100%;
    margin: 0 auto;
    width: 480px;
    top: 25%;
  }
}

@media screen and (orientation:landscape) and (max-height: 360px) {
  .video-wrapper {
    max-height: 100%;
    margin: 0 auto;
    width: 391px;
    top: 0%;
  }
}

/*Tag Sup*/
.bottom-banner sup,
.top-banner sup {
  font-size: 11px;
  font-weight: 400;
  margin: 0 0 0 2px;
  vertical-align: 4px;
  line-height: 1;
}

@media screen and (max-width: 540px) {

  .top-banner sup,
  .bottom-banner sup {
    font-size: 8px;
    line-height: 1;
    vertical-align: 4px;
  }
}

/*. Tag Sup*/
</style>



// WEBPACK FOOTER //
// src/components/Collaborative_Care_Resources.vue